export const NON_LEGACY_SUBSCRIPTION_PLAN_REGEX = /-\d{3}$/;
